import React, { Component } from 'react';
import Icon from './Icon';

// Import the CSS
import '../../scss/components/_pagination.scss';

export default class Pagination extends Component {
	constructor(props) {
		super(props);
		this.onSelectPage = this.onSelectPage.bind(this);
	}

	onSelectPage(page) {
		return e => {
			if (page < 1 || page > this.props.totalPages) {
				return;
			}
			this.props.onPageChange(page);

			//Scroll to the Top!
			var timerID = setInterval(function() {
				if (window.scrollY > 100) {
					window.scrollBy(0, -15);
				} else {
					window.scrollBy(0, -10);
				}

				if (window.scrollY <= 0) clearInterval(timerID);
			}, 1);
		};
	}

	render() {
		let pages = [];

		//HIDE if ONLY 1 page
		if (this.props.totalPages <= 1) {
			return <div></div>;
		}

		if (this.props.totalPages < 10) {
			for (var i = 1; i < this.props.totalPages + 1; i++) {
				pages.push(genPage(i, this.props.currentPage, this.onSelectPage));
			}
		} else {
			for (var i = 1; i < this.props.totalPages + 1; i++) {
				let page = genPage(i, this.props.currentPage, this.onSelectPage);

				if (i == 1 || i == this.props.totalPages) {
					pages.push(page);
					continue;
				}

				let breakLabel;
				if (i > this.props.currentPage - 3 && i <= this.props.currentPage + 2) {
					//place break label before first shown page
					if (i < this.props.currentPage - 1) {
						breakLabel = <BreakLabel hidden={i <= 2} key={'breakLabelFirst-' + i} />;
						pages.push(breakLabel);
					}

					pages.push(page);

					//place break label after last shown page
					if (i >= Math.floor(this.props.currentPage + 2)) {
						breakLabel = (
							<BreakLabel
								hidden={i > this.props.totalPages - 2}
								key={'breakLabelLast-' + i}
							/>
						);
						pages.push(breakLabel);
					}
				}
			}
		}

		return (
			<div className="pagination row row-align-center">
				<Icon
					type="chevron-left"
					onClick={this.onSelectPage(this.props.currentPage - 1)}
					className={this.props.currentPage === 1 ? 'disabled' : ''}
				/>
				{pages}
				<Icon
					type="chevron-right"
					onClick={this.onSelectPage(this.props.currentPage + 1)}
					className={this.props.currentPage === this.props.totalPages ? 'disabled' : ''}
				/>
			</div>
		);
	}
}

Pagination.propTypes = {
	totalPages: React.PropTypes.number.isRequired,
	currentPage: React.PropTypes.number.isRequired,
	onPageChange: React.PropTypes.func.isRequired,
};

function genPage(index, currentPage, onSelectPage) {
	let classes = ['page'];
	if (index == currentPage) {
		classes.push('selected');
	}
	return (
		<Page key={index} index={index} classes={classes.join(' ')} onClick={onSelectPage(index)} />
	);
}

class BreakLabel extends Component {
	render() {
		var cssClass = this.props.hidden ? 'hidden' : '';
		return <span className={cssClass}>...</span>;
	}
}

class Page extends Component {
	render() {
		return (
			<div className={this.props.classes} onClick={this.props.onClick}>
				<span className="selected-page">{this.props.index}</span>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/assets/js/components/Pagination.js